import React, { useEffect, useState } from "react";
import Form from "../../components/Form/Form";
import { useFormConfig } from "./QuizFieldsConfig";
import { addQuiz, updateQuiz } from "../../services/QuizService";
import { useLocation } from "react-router-dom";

function QuizForm({ onClose }) {
  const location = useLocation();
  const { mode, quiz } = location.state || {};

  const initialQuizData = mode === "update" && quiz ? {
    title: quiz.QuizTranslations?.title || "",
    quizType: quiz.quiz_type || "",
    courseId: quiz.course_id || "",
    moduleId: quiz.module_id || "",
    topicId: quiz.topic_id || "",
    totalQuestions: quiz.total_questions || "",
    roleIds: quiz.role_ids || [],
    startDate: quiz.start_date ? new Date(quiz.start_date) : "",
    endDate: quiz.end_date ? new Date(quiz.end_date) : "",
    publishDate: quiz.published_date ? new Date(quiz.published_date) : "",
  } : {
    title: "",
    quizType: "",
    courseId: "",
    moduleId: "",
    topicId: "",
    totalQuestions: "",
    roleIds: [],
    startDate: "",
    endDate: "",
    publishDate: "",
  };

  const { quizForm } = useFormConfig(initialQuizData, mode);
  const [formData, setFormData] = useState(initialQuizData);

  useEffect(() => {
    setFormData(initialQuizData);
  }, [mode, quiz]);

  const handleSubmit = async (quizFormData) => {
    try {
      if (mode === "update" && quiz) {
        await updateQuiz(quiz.id, quizFormData);
      } else {
        await addQuiz(quizFormData);
      }
      onClose();
    } catch (error) {
      console.error("Error submitting quiz:", error);
    }
  };

  return (
    <Form
      formTitle={quizForm.formTitle}
      initialFormData={formData}
      fieldConfig={quizForm.fieldConfig}
      onSubmit={handleSubmit}
      onClose={onClose}
      mode={mode}
    />
  );
}

export default QuizForm;